'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var FooterCopyright = function FooterCopyright() {
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "ft-copyright"
  }, /*#__PURE__*/React__default['default'].createElement("p", {
    className: "copyright-item managed-by-item"
  }, "Managed by", ' ', /*#__PURE__*/React__default['default'].createElement("a", {
    href: "https://www.triadns.org"
  }, "Triad National Security, LLC"), " for the ", /*#__PURE__*/React__default['default'].createElement("a", {
    href: "https://nnsa.energy.gov"
  }, "U.S. Dept. of Energy\u2019s NNSA")), /*#__PURE__*/React__default['default'].createElement("p", {
    className: "copyright-item"
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    "data-testid": "copyright-link",
    href: "https://www.lanl.gov/resources/web-policies/copyright-legal.php"
  }, "Copyright 2022 Triad National Security, LLC. All Rights Reserved.")), /*#__PURE__*/React__default['default'].createElement("p", {
    className: "copyright-item disclosure-text"
  }, "Learn about the Department of Energy\u2019s", ' ', /*#__PURE__*/React__default['default'].createElement("a", {
    target: "_blank",
    href: "https://doe.responsibledisclosure.com/hc/en-us",
    rel: "noreferrer"
  }, "Vulnerability Disclosure Program")));
};

exports.FooterCopyright = FooterCopyright;
exports['default'] = FooterCopyright;